import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div><!></div>`);

function Card($$anchor, $$props) {
	$.push($$props, true);

	let padding = $.prop($$props, 'padding', 3, 'md');
	var div = root();
	let classes;
	var node = $.child(div);

	$.snippet(node, () => $$props.children);
	$.reset(div);

	$.template_effect(() => {
		classes = $.set_class(div, 1, `card card-${padding() ?? ''}`, 'svelte-49f6y3rrzei5', classes, { interactive: !!$$props.onclick });
		$.set_attribute(div, 'role', $$props.onclick ? 'button' : undefined);
		$.set_attribute(div, 'tabindex', $$props.onclick ? 0 : undefined);
	});

	$.delegated('click', div, function (...$$args) {
		$$props.onclick?.apply(this, $$args);
	});

	$.delegated('keydown', div, (e) => {
		if ($$props.onclick && (e.key === 'Enter' || e.key === ' ')) {
			e.preventDefault();
			$$props.onclick(e);
		}
	});

	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	Card = $.hmr(Card);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-49f6y3rrzei5');
		Card[$.HMR].update(module.default);
	});
}

export default Card;

$.delegate(['click', 'keydown']);
import "bun-svelte:Card.svelte-o31atospjrwz-style.css";